export default {
  'workOrder.home.welcome': '歡迎使用',
  'workOrder.common.create': '新增工單',
  'workOrder.common.refresh': '重新整理資料',
  'workOrder.common.reload': '重新載入',
  'workOrder.common.view': '檢視',
  'workOrder.common.all': '全部',
  'workOrder.common.none': '暫無資料',
  'workOrder.status.pending_accept': '待受理',
  'workOrder.status.processing': '處理中',
  'workOrder.status.pending_confirm': '待確認',
  'workOrder.status.closed': '已辦結',
  'workOrder.status.cancelled': '已取消',
  'workOrder.priority.low': '低',
  'workOrder.priority.normal': '一般',
  'workOrder.priority.high': '高',
  'workOrder.priority.critical': '緊急',
  'workOrder.list.title.all': '全部工單',
  'workOrder.list.title.todo': '我的待辦',
  'workOrder.list.title.mine': '我的工單',
  'workOrder.list.ticketNo': '編號',
  'workOrder.list.workOrderTitle': '標題',
  'workOrder.list.priority': '優先級',
  'workOrder.list.status': '狀態',
  'workOrder.list.createdAt': '建立時間',
  'workOrder.list.actions': '操作',
  'workOrder.create.title': '新增工單',
  'workOrder.create.titleWithTemplate': '新增 {name}',
  'workOrder.create.submit': '提交工單',
  'workOrder.create.submitted': '工單已提交',
  'workOrder.create.basicInfo': '基本資訊',
  'workOrder.create.extendedInfo': '擴充資訊',
  'workOrder.create.template': '工單範本',
  'workOrder.create.templateRequired': '請選擇工單範本',
  'workOrder.create.workOrderTitle': '工單標題',
  'workOrder.create.titleRequired': '請輸入工單標題',
  'workOrder.template.title': '工單範本',
  'workOrder.template.create': '新增範本',
  'workOrder.template.name': '範本名稱',
  'workOrder.template.code': '範本編碼',
  'workOrder.template.currentVersion': '目前版本',
  'workOrder.template.unpublished': '未發佈',
  'workOrder.template.status': '狀態',
  'workOrder.template.draft': '草稿',
  'workOrder.template.published': '已發佈',
  'workOrder.template.enabled': '啟用',
  'workOrder.template.disabled': '停用',
  'workOrder.template.lastPublishedAt': '最近發佈時間',
  'workOrder.template.configure': '設定',
  'workOrder.template.copy': '複製',
  'workOrder.template.copied': '範本已複製',
  'workOrder.form.uploadAttachment': '上傳附件',
  'workOrder.puck.options': '選項清單，每行一個，格式為顯示名稱|編碼',
  'workOrder.puck.code': '系統編碼',
  'workOrder.puck.label': '顯示名稱',
  'workOrder.puck.helpText': '說明文字',
  'workOrder.puck.placeholder': '預留提示',
  'workOrder.puck.required': '是否必填',
  'workOrder.puck.no': '否',
  'workOrder.puck.yes': '是',
  'workOrder.puck.initiatePermission': '發起階段',
  'workOrder.puck.processPermission': '處理階段',
  'workOrder.puck.editable': '可編輯',
  'workOrder.puck.readonly': '唯讀',
  'workOrder.puck.hidden': '隱藏',
  'workOrder.puck.conditionFieldCode': '條件欄位編碼',
  'workOrder.puck.conditionOperator': '條件操作',
  'workOrder.puck.equals': '等於',
  'workOrder.puck.notEquals': '不等於',
  'workOrder.puck.contains': '包含',
  'workOrder.puck.notEmpty': '不為空',
  'workOrder.puck.conditionValue': '條件值',
  'workOrder.puck.attachmentAccept': '允許類型',
  'workOrder.puck.attachmentSize': '單一檔案大小（MB）',
  'workOrder.puck.attachmentCount': '最多檔案數',
  'workOrder.puck.selectFile': '選擇檔案',
  'workOrder.puck.fields': '工單欄位',
  'workOrder.puck.layouts': '版面元件',
  'workOrder.puck.text': '單行文字',
  'workOrder.puck.textarea': '多行文字',
  'workOrder.puck.number': '數字',
  'workOrder.puck.select': '單選',
  'workOrder.puck.multiSelect': '多選',
  'workOrder.puck.date': '日期',
  'workOrder.puck.dateRange': '日期範圍',
  'workOrder.puck.member': '成員選擇',
  'workOrder.puck.attachment': '附件',
  'workOrder.puck.switch': '開關',
  'workOrder.puck.oneColumn': '一欄版面',
  'workOrder.puck.twoColumn': '兩欄版面',
  'workOrder.puck.layoutName': '版面名稱',
  'workOrder.puck.group': '群組',
  'workOrder.puck.groupName': '群組名稱',
  'workOrder.puck.fieldGroup': '欄位群組',
  'workOrder.editor.publishCheckFailed': '發佈檢查未通過',
  'workOrder.editor.published': '範本已發佈',
  'workOrder.editor.draftSaved': '草稿已儲存',
  'workOrder.editor.publishFailed': '範本發佈失敗，請稍後再試',
  'workOrder.editor.draftSaveFailed': '草稿儲存失敗，請稍後再試',
  'workOrder.editor.editTitle': '編輯範本',
  'workOrder.editor.saveDraft': '儲存草稿',
  'workOrder.editor.publish': '發佈範本',
  'workOrder.editor.basicInfo': '基本資訊',
  'workOrder.editor.formDesign': '表單設計',
  'workOrder.editor.workflow': '流程設定',
  'workOrder.editor.sla': 'SLA 設定',
  'workOrder.editor.publishCheck': '發佈檢查',
  'workOrder.editor.nameRequired': '請輸入範本名稱',
  'workOrder.editor.codeInvalid': '編碼只能使用小寫字母、數字與底線',
  'workOrder.editor.description': '範本說明',
  'workOrder.editor.statCategory': '統計分類',
  'workOrder.editor.enabled': '啟用狀態',
  'workOrder.editor.preview': '即時預覽',
  'workOrder.editor.deleteNode': '刪除節點',
  'workOrder.editor.nodeCode': '節點編碼',
  'workOrder.editor.nodeName': '節點名稱',
  'workOrder.editor.nodeType.accept': '受理',
  'workOrder.editor.nodeType.process': '處理',
  'workOrder.editor.nodeType.ownerConfirm': '負責人確認',
  'workOrder.editor.nodeType.requesterConfirm': '發起人確認',
  'workOrder.editor.assignee.member': '指定成員',
  'workOrder.editor.assignee.role': '組織角色',
  'workOrder.editor.assignee.group': '候選群組',
  'workOrder.editor.selectAssignee': '選擇負責人',
  'workOrder.editor.assigneeCode': '負責人編碼',
  'workOrder.editor.responseMinutes': '回應分鐘',
  'workOrder.editor.processMinutes': '處理分鐘',
  'workOrder.editor.requiresResult': '要求處理結果',
  'workOrder.editor.addNode': '新增節點',
  'workOrder.editor.warningLeadTime': '預警提前量',
  'workOrder.editor.minutes': '{value} 分鐘',
  'workOrder.editor.hour': '1 小時',
  'workOrder.editor.recheck': '重新檢查',
  'workOrder.editor.emptyChecks': '點擊重新檢查以產生檢查結果',
  'workOrder.editor.passed': '通過',
  'workOrder.editor.failed': '未通過',
  'workOrder.editor.previous': '上一步',
  'workOrder.editor.next': '下一步',
};
